import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginationQuery} from "../../../core/services/api.service";
import {Pagination} from "../../../core/shared/classes/pagination";
import {ApiResponse} from "../../../core/shared/classes/api";

export function handelPaginationResponse(response: ApiResponse): Pagination  {
  let res = null;

  if (response.status === 200 && response.data.pagination)
    res = response.data.pagination;

  return res;
}

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input()  pagination: Pagination;
  @Input()  query:      PaginationQuery;

  @Output() fetchItems = new EventEmitter<PaginationQuery>();

  pageSizeOption = [5, 10, 25, 100];

  constructor() { }

  ngOnInit() {
  }

  onPageChange($event) {
    if ($event.pageSize !== this.query.perPage) {
      this.query.perPage = $event.pageSize;
      this.fetchItems.emit(this.query);
    } else if (($event.pageIndex + 1) !== this.query.page) {
      this.query.page = ($event.pageIndex + 1);
      this.fetchItems.emit(this.query);
    }
  }
}
